import React, { Component } from 'react';
import { IntlProvider } from 'react-intl';
import { connect, useSelector } from 'react-redux';
import { Redirect, Router, Route, Switch } from 'react-router-dom';
import { compose } from 'redux';

import { ConnectedProgress } from 'components/ConnectedProgress';
import PageNotFound from 'components/PageNotFound';
import SignIn from 'components/SignIn';

import { Storage } from 'services/Storage';
import { getBidConfig } from 'services/util';

import { history } from 'util/history';
import { loadable } from 'util/loadable';
import { isEmpty, logWarn } from 'util/utils';

import AppLocale from 'lngProvider';

import Routes from './Routes';

const SignUp = loadable(() => import('components/SignUp'));
const DiamondDetail = loadable(() => import('components/DiamondDetail'));
const RapnetDetailPage = loadable(() => import('components/DiamondDetail/RapnetDetailPage'));
const DNA = loadable(() => import('components/DNA'));
const EmailVerify = loadable(() => import('components/EmailVerify'));
const ForgotPassword = loadable(() => import('components/Auth/ForgotPassword'));
const GuestLogin = loadable(() => import('components/GuestLogin'));
const ResetPassword = loadable(() => import('components/Auth/ResetPassword'));
const ThankYouAfterSignup = loadable(() => import('components/ThankYou'));
const VerifyOtp = loadable(() => import('components/VerifyOtp'));
const DownloadFullStock = loadable(() => import('components/DownloadFullStock'));


const SignOutRoute = React.memo(({ component: Component, ...rest }) => {
  const token = useSelector((state) => state.auth?.token);
  return (
    <Route {...rest} render={(props) => (isEmpty(token) ? <Component {...props} /> : <Redirect to={'/dashboard'} />)} />
  );
});
SignOutRoute.displayName = 'SignOutRoute';

class Root extends Component {
  async setBidStatus() {
    // TODO: replace this function with reducer
    if (isEmpty(this.props.token)) {
      Storage.delete('bid-status');
      Storage.delete('bid-sub-type-code');
      return;
    }

    try {
      const bidConfig = await getBidConfig();
      Storage.set('bid-status', bidConfig?.sub_types?.allowDiamondFilterWSts);
      Storage.set('bid-sub-type-code', bidConfig?.sub_types?.subTypeCode);
    } catch (error) {
      logWarn(error);
    }
  }

  componentDidMount() {
    this.setBidStatus();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.token !== this.props.token) {
      this.setBidStatus();
    }
  }

  render() {
    const locale = this.props.commonData?.locale?.locale ?? 'en';
    const currentAppLocale = AppLocale[locale];

    return (
      <Router history={history}>
        <ConnectedProgress />
        <IntlProvider locale={currentAppLocale.locale} messages={currentAppLocale.messages}>
          <Switch>
            <SignOutRoute path="/" component={SignIn} exact />
            <SignOutRoute path="/signin" component={SignIn} />
            <SignOutRoute path="/signup" component={SignUp} />
            <SignOutRoute path="/device/signup" component={SignUp} />
            <SignOutRoute path="/guest-login" component={GuestLogin} />
            <SignOutRoute path="/forgot-password" component={ForgotPassword} />
            <SignOutRoute path="/forgot-password" component={ForgotPassword} />
            <Route path="/download-full-stock" component={DownloadFullStock} />
            <Route path="/reset-password/:token" component={ResetPassword} />

            <Route exact path="/verify-otp" component={VerifyOtp} />
            <Route path="/thank-you" component={ThankYouAfterSignup} />
            <Route path="/verify-email" component={EmailVerify} />
            <Route path="/dna" component={DNA} />
            <Route path="/diamond-detail/:id" component={DiamondDetail} />
            <Route path="/diamond-dna/:id" component={RapnetDetailPage} />
            <Route exact path="/not-found" component={PageNotFound} />

            <Routes />
          </Switch>
        </IntlProvider>
      </Router>
    );
  }
}

export default compose(
  connect((state) => ({
    commonData: state.commonData,
    token: state.auth?.token,
  })),
)(Root);
